  <div class="modal-header">
      <h3 id="modal-basic-title" class="modal-title">{{ 'roomsPage.room' | translate }} {{roomId}}</h3>
      <button type="button" class="close" (click)="activeModal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button>
  </div>

      <div class="modal-body">

          <div id="roomDetailContainer">
              
              <div id="roomDetailSection" class="row mt-5">
                  <div class="roomImgSection col-xl-6">
                      <img class="roomImg" src="assets/images/rooms/{{room.id}}.jpg" alt="">
                      <div id="roomIcons">
                        <ng-container *ngFor="let icon of room.icons">
                            <img src="assets/images/icons/{{icon}}.png" alt="">
                        </ng-container>
                        <!-- Font Awesome Solid Icons -->
                        <!-- <ng-container *ngFor="let icon of room.icons">
                            <i class="fas fa-{{icon}}"></i>
                        </ng-container> -->
                      </div>
                    </div>
                    <div class="airbnbButtonMobile col text-center">
                        <app-airbnb-button></app-airbnb-button>
                    </div>
                    <div class="col-xl-6">
                      <div id="roomServices">
                        <div *ngFor="let service of room.services">
                          <label class="mb-0 mt-3">{{service.serviceType}}</label>
                          <ul class="text-left" *ngFor="let serviceItem of service.serviceItems">
                            <li>{{serviceItem.item}}</li>
                          </ul>
                        </div>
                      </div>
                    <!-- <div class="col-lg-3">
                      <div>
                        
                      </div>
                    </div> -->
                
              </div>
          
              <div class="airbnbButtonDesktop row w-100 mt-4">
                  <div class="col text-center">
                      <app-airbnb-button [airbnbLink]="room.links.airbnb"></app-airbnb-button>
                  </div>
              </div>
          
          </div>

          
      </div>

